<template>
  <div class="QRcode container-fluid">
    <div class="row">
        <div class="col mainBar">
          <div >
            <div v-bind:toolSelection="selected">
              <div class="col topText">
                <div class="title">
                  {{tool[0].title}}
                </div>
                <div class="row">
                <div class="col-12">
                  <div class="screenshots">
                    <img :src="tool[0].image1">
                  </div>
                </div>
              </div>
                <div class="techUsed">
                  {{tool[0].techUsed}}
                </div>
                <div class="content">
                  {{tool[0].content}}
                </div>
              </div>
            </div>
          </div> 

          <div>
              <div class="row">
                <div class="col">
                  <div class="mini-screenshots">
                    <img :src="tool[0].image2">
                  </div>
                </div>
              </div>

            <div class="row">
              <div class="col">
                <div class="issues">
                  <b>Source Code:</b> <span style="font-style:italic"> {{tool[0].sourceCodeAvailability}}</span><br>
                </div>
              </div>
            </div>
          </div>
        </div>
    
    </div>
  </div>
</template>

<script>
export default {
  name: 'QRcode',
  data:() =>({
    tool: [{
      title: "QRcode creator",
      techUsed: "Python3.5, PySide2 (gui),ImageMagick (image processing),PIL (saving images), Virtualenv (encapsulation of dependencies)",
      content: "This program generate a QR code based on data from an excel file.\n\nCe programme génère un code QR basé sur les données d'un fichier excel.",
      sourceCodeAvailability: "Unavailable, proprietary code",
      image1: require("@/assets/tools/QRcodes/GUI_qrcodes.png"),
      image2: require("@/assets/tools/QRcodes/QRcodesInfo.png")
    }]
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Fredoka+One&display=swap');

.QRcode{
  font-family: 'Roboto', sans-serif;
  max-width: 700px;
  white-space:pre-wrap;
}
.topText{
  display: block;
}
.title{
  font-family: 'Fredoka One', cursive;
  text-align:center;
  font-weight: 700;
  font-size: 1.5em;
  margin-bottom: 2%;
}
.techUsed{
  font-style: italic;
  font-weight: 100;
  font-size: 0.7em;
  text-align: justify;
  margin-bottom: 3%;
}
.content{
  text-align: justify;
  margin-bottom: 4%;
  text-align: justify;
  font-size: 0.8em;
}
.screenshots{
  text-align:center;
  margin-left: 20%;
  margin-right: 20%;
  padding-bottom: 3%;
  height: auto;
}
.mini-screenshots{
    text-align:center;
  margin-left: 35%;
  margin-right: 35%;
  padding-bottom: 3%;
  height: auto;
}
.issues{
  text-align: center;
  font-size: 0.7em;
}
img{
  width:100%;
  height: 100%;
}
</style>
